import { jsxs, jsx } from 'react/jsx-runtime';
import logger from '@agoras/logger';
import { mergeStyleSets, FontWeights, NeutralColors, Stack, Text, Nav } from '@fluentui/react';
import { useHeaderButtons } from '../../TopHeader/Buttons/useHeaderButtons.esm.js';
import { useHeaderPanel } from '../../../../hooks/useHeaderPanel.esm.js';
import { useTranslation } from 'react-i18next';
import { headerContext } from '../../context.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var classNames = mergeStyleSets({
    title: {
        fontWeight: FontWeights.semibold
    }
});
var navStyles = {
    groupContent: {
        marginTop: 16,
        marginBottom: 0,
        animation: 'none'
    },
    linkText: {
        color: 'inherit',
        marginLeft: 12
    },
    link: {
        color: NeutralColors.gray160,
        cursor: 'pointer',
        '&:disabled': {
            color: NeutralColors.gray90,
            cursor: 'default'
        }
    }
};
var navLinkIconStyles = {
    root: {
        fontSize: 16,
        margin: 0
    }
};
var AccountAndSettings = function(param) {
    var onItemClick = param.onItemClick;
    var _useHeaderButtons = _sliced_to_array(useHeaderButtons(), 1), headerButtons = _useHeaderButtons[0];
    var t = useTranslation('header').t;
    var setOpenPanelKey = useHeaderPanel().setOpenPanelKey;
    var navLinkGroups = headerButtons.map(function(param) {
        var key = param.key, onClick = param.onClick, iconName = param.iconName, ariaLabel = param.ariaLabel, fullText = param.fullText, relatedPanel = param.relatedPanel, disabled = param.disabled, _param_href = param.href, href = _param_href === void 0 ? '' : _param_href;
        return {
            name: fullText,
            url: href,
            ariaLabel: ariaLabel,
            disabled: disabled,
            iconProps: {
                styles: navLinkIconStyles,
                iconName: iconName
            },
            onClick: function() {
                logger.info(JSON.stringify({
                    key: 'AccountAndSettings',
                    name: key
                }), _object_spread({
                    action: 'AllMenu',
                    actionModifier: 'Click'
                }, headerContext));
                if (relatedPanel) {
                    setOpenPanelKey(key);
                }
                onClick === null || onClick === void 0 ? void 0 : onClick();
                onItemClick();
            }
        };
    });
    return /*#__PURE__*/ jsxs(Stack, {
        children: [
            /*#__PURE__*/ jsx(Text, {
                variant: "mediumPlus",
                className: classNames.title,
                children: t('Account & Settings')
            }),
            /*#__PURE__*/ jsx(Nav, {
                styles: navStyles,
                ariaLabel: t('Account & Settings items'),
                groups: [
                    {
                        links: navLinkGroups
                    }
                ]
            })
        ]
    });
};

export { AccountAndSettings as default };
